import React, { useEffect, useState } from 'react';
import { history, connect } from 'umi';
import { isEmpty, cloneDeep } from 'lodash';

import { Skeleton } from 'antd';
import { ConfigProvider } from 'antd-mobile';
import enUS from 'antd-mobile/es/locales/en-US';
import { GlobalTokenProvider, tokenManager } from '@digitalc/dxp-ui';
import useGCPI18n from '@/hooks/useGCPI18n';
import { sensorsInit, initGoogleGA } from '@/utils/sensors';
import { getAppInfo, getBrandInfo, getDeviceType } from '@/utils/utils';
import { Clickable } from '@/components';
import clpLogo from '@/assets/images/ic_logo.png';
import clpTitleImg from '@/assets/images/ic_activity@2x.png';
import ditoLogo from '@/assets/images/ditoLogo.png';
import ditoTitle from '@/assets/images/ditoTitle.png';
import tmlogo from '@/assets/images/notLogin/tmLogo.png';
import tmBg from '@/assets/images/notLogin/tmDownloadBg.png';
import localToken from '@/constant/token_json.json';
import TokenManager from '@/utils/TokenManager';
import tokenJson from '@/utils/token.json';
import tokenHiapp from '@/utils/token_HIAPP.json';
import webTokenJson from '@/utils/webToken.json';
// import 'antd-mobile/es/global'
import styles from './index.less';

const JumpAppDetail = {
  CLP: {
    dowmloadUrl:
      'https://www.pgyer.com/zTY9?sig=2n28dPD2K%2BzcyCWkmjJUqhW%2FThZY44RZ3jWWjUtFoO3d17VVY9z6NJXL5hLEHVGg',
    titleImg: clpTitleImg,
    logo: clpLogo,
    locationHrefSuffix: 'clp://',
  },
  DITO: {
    dowmloadUrl: 'https://bit.ly/getDITOApp',
    titleImg: ditoTitle,
    logo: ditoLogo,
    // locationHrefSuffix: 'mydito://',
    locationHrefSuffix: 'mydito://schemaType=2&schemaUrl=',
    btnClassName: styles.ditoBtn,
  },
  TM: {
    dowmloadUrl: '',
    titleImg: tmBg,
    logo: tmlogo,
    locationHrefSuffix: 'clp://',
    btnClassName: styles.tmBtn,
  },
};

const BaseLayout = props => {
  const { children, dispatch, isWeb } = props;
  const { pathname } = history.location || {};
  const { linkCode } = history.location.query;
  const shortLink = JSON.stringify({ linkCode });
  const GCPI18n = useGCPI18n();
  const [downloadApp, setDownloadApp] = useState(false);
  const [open, setOpen] = useState(false);
  const [appKey, setAppKey] = useState('TM');
  const [appDetail, setAppDetail] = useState(JumpAppDetail.TM);
  const [luckyDrawPage, setLuckyDrawPage] = useState(false);
  const [openDisabled, setOpenDisabled] = useState(false);
  const [loading, setLoading] = useState(false);

  // 根据品牌与设备类型拉取主题 token 并写入全局状态/CSS 变量（多处复用，抽公共逻辑）
  const loadThemeToken = (appCode, tokenJsonTemp, isUtm) => {
    dispatch({
      type: 'index/qryThemesLatest',
      payload: {
        appCode,
      },
    }).then(themeRes => {
      const cachedThemeStr = window.localStorage.getItem('gcpTheme') || '{}';
      const cachedTheme = JSON.parse(cachedThemeStr) || {};
      if (cachedTheme.version !== themeRes.version || cachedTheme.themeName !== themeRes.themeName) {
        window.localStorage.setItem('gcpTheme', JSON.stringify(themeRes));
      }
      tokenManager.loadExternalToken(themeRes?.tokenJson || tokenJsonTemp);
      dispatch({
        type: 'index/save',
        payload: {
          dxpToken: themeRes?.tokenJson || tokenJsonTemp,
        },
      });
      // 更新 CSS 变量
      document.documentElement.style.setProperty(
        '--global-font-family',
        (themeRes?.tokenJson || tokenJsonTemp)?.fontFamilySecondaryRegular || 'Roboto', // 回退字体
      );
      if (isUtm) {
        setLoading(false);
        setLuckyDrawPage(true);
      }
    });
  };

  // 根据客户端标识挑选本地 token 配置（多处复用）
  const pickLocalTokenJson = (clientKey, isWebTemp) => {
    if (clientKey === 'HIAPP') {
      return tokenHiapp;
    }
    if (isWebTemp) {
      return webTokenJson;
    }
    return tokenJson;
  };

  const qryApiSgAuthToken = async () => {
    // 查 access token
    const payload = new URLSearchParams();
    payload.append('grant_type', 'client_credentials');
    const sgToken = await dispatch({
      type: 'index/qryApiSgAuthToken',
      payload,
    });
    sessionStorage.removeItem('sg-access-token');
    if (!isEmpty(sgToken) && sgToken.expires_in) {
      sessionStorage.setItem('sg-access-token', sgToken.access_token);
      let timer = setInterval(() => {
        // 计算过期时间
        const expiresTime =
          parseInt(sgToken.expires_in, 10) + parseInt(sgToken.issued_at, 10) / 1000;
        const nowTime = new Date().getTime() / 1000;
        if (expiresTime - nowTime < 30) {
          clearInterval(timer);
          timer = null;
          // 过期，重新获取
          qryApiSgAuthToken();
        }
      }, 5 * 1000);
    }
  };

  // useEffect(async () => {
  //   await dispatch({
  //     type: 'index/qryDefaultConfig',
  //   });
  //   // // 查 access token
  //   // await qryApiSgAuthToken();
  //   let defaultConfig = {};
  //   try {
  //     defaultConfig = JSON.parse(window.sessionStorage.getItem('x-default-config')) || {};
  //   } catch {
  //     //
  //   }
  //   if (defaultConfig?.APIGEE_TOKEN_ENABLED) {
  //     // 查 access token
  //     await qryApiSgAuthToken();
  //   }
  // }, []);

  const openApp = () => {
    if (openDisabled) {
      return;
    }
    setOpenDisabled(true);
    if (appDetail.locationHrefSuffix) {
      window.location.href = `${appDetail.locationHrefSuffix}${window.location.href}`;
    }
    window.setTimeout(() => {
      setDownloadApp(true);
      setOpenDisabled(false);
    }, 1000);
  };

  const copyTo = () => {
    const oInput = document.createElement('input'); // 创建一个input
    oInput.value = shortLink; // 给要复制的内容赋值input的value
    document.body.appendChild(oInput); // body中添加input
    oInput.select(); // 选择对象 .select()获取文本域中的内容
    document.execCommand('Copy'); // 执行浏览器复制命令
    oInput.style.display = 'none'; // 把input隐藏
  };

  const copy = () => {
    copyTo(); // 把要复制的内容传入到copyTo方法
    openApp();
  };

  const renderOpenApp = () => {
    /**
     * Render action button (download or open)
     * @param {Object} params
     * @param {boolean} params.isDownload - Whether to show download button
     * @param {boolean} params.wrapInLink - Whether to wrap in anchor tag
     */
    const renderActionButton = ({ isDownload, wrapInLink }) => {
      const button = (
        <Clickable
          className={`${styles.downLoadApp} ${appDetail.btnClassName || ''}`}
          onClick={isDownload ? copyTo : copy}
          id="text"
        >
          {GCPI18n({ id: isDownload ? 'lb_btn_download_app' : 'lb_btn_open_app' })}
        </Clickable>
      );

      return isDownload && wrapInLink ? (
        <a style={{ color: '#000' }} href={appDetail.dowmloadUrl}>
          {button}
        </a>
      ) : (
        button
      );
    };

    if (appKey === 'TM') {
      return (
        <div
          className={`${styles.page} ${styles.tmPage}`}
          style={{ backgroundImage: `url(${appDetail.titleImg})` }}
        >
          <div className={styles.tmLogoBox}>
            <img src={appDetail.logo} alt="" />
            {renderActionButton({
              isDownload: downloadApp,
              wrapInLink: true,
            })}
          </div>
        </div>
      );
    }
    return (
      <div className={styles.page}>
        <div className={styles.container}>
          <img className={styles.titleImg} src={appDetail.titleImg} alt="" />
          <div className={styles.clpLogoImg}>
            <img src={appDetail.logo} alt="" />
          </div>
          {renderActionButton({
            isDownload: downloadApp,
            wrapInLink: true,
          })}
        </div>
      </div>
    );
  };

  const isLogin = async configList => {
    // await dispatch({
    //   type: 'index/qryTimeDisplayFormate',
    //   payload: {
    //     paramCode: 'TIME_DISPLAY_FORMAT',
    //   },
    // });
    // 优先设置埋点配置数据
    // const result = await dispatch({
    //   type: 'index/qrySensorsServerUrl',
    //   payload: 'EVENT_REPORT_SERVER_URL',
    // });
    const sensorsInitObj =
      configList.find(item => item.paramCode === 'EVENT_REPORT_SERVER_URL') || {};
    sensorsInit(sensorsInitObj.paramValue).quick('autoTrack');
    // 通过独立接口获取谷歌埋点上报配置
    const gaConfigValue = await dispatch({
      type: 'index/getGAReportConfig',
    });
    initGoogleGA(gaConfigValue);
    setLuckyDrawPage(true);
    // if (isEmpty(localStorage.getItem('timeFormate'))) {
    //   dispatch({
    //     type: 'index/qryTimeDisplayFormate',
    //     payload: {
    //       paramCode: 'TIME_DISPLAY_FORMAT',
    //     },
    //   });
    // }
  };

  const notLogin = async projectName => {
    // let appCode = await dispatch({
    //   type: 'index/qryAppCode',
    // });
    // if (isEmpty(appCode)) {
    //   return;
    // }
    let appCode = 'CLP';
    if (projectName === 'PTO') {
      appCode = 'DITO';
    }
    if (projectName === 'TM') {
      appCode = 'TM';
    }
    setAppKey(appCode);
    setAppDetail(JumpAppDetail[appCode] || {});
    setOpen(true);
    setLuckyDrawPage(false);
  };

  const initLocalStorage = () => {
    window.localStorage.removeItem('promotionId');
    window.localStorage.removeItem('tabIndex');
    window.localStorage.removeItem('initApp');
  };

  // dxp获取用户信息，不管是在app中还是在浏览器，都通过这个接口获取用户信息
  const qryUserInfoByTokenDXP = async () => {
    const response = await dispatch({
      type: 'index/qryUserInfoDXP',
    });

    const nationalRes = await dispatch({
      type: 'index/qryNationalPrefix',
    });
    let displayPhone = response?.mobile || '';
    if (
      nationalRes.showTrunkPrefix &&
      nationalRes.trunkPrefix &&
      !displayPhone.startsWith(nationalRes.trunkPrefix)
    ) {
      displayPhone = `${nationalRes.trunkPrefix}${displayPhone}`;
    }

    const urlParams = history.location.query || {};
    const initAppStr = window.localStorage.getItem('initApp') || '{}';
    // 这里被置空了，重置
    const initApp = {
      tenantId: 0,
      userType: 1,
      ...urlParams,
      ...(JSON.parse(initAppStr) || {}),
      ...response,
      phone: response?.mobile,
      partyName: response?.userName,
      accNbr: response?.sessionInfo?.serviceNumber,
      displayPhone,
    };
    // return;
    window.localStorage.setItem('initApp', JSON.stringify(initApp));
  };

  // 通过UC获取用户信息，如果是在app中还是通过桥接获取，这个方法主要是用于浏览器
  const qryUserInfoByToken = async (token, configList) => {
    const response = await dispatch({
      type: 'index/qryUserInfo',
      payload: { token },
    });
    const urlParams = history.location.query || {};
    const initAppStr = window.localStorage.getItem('initApp') || '{}';
    // 这里被置空了，重置
    const initApp = {
      tenantId: 0,
      userType: 1,
      ...(JSON.parse(initAppStr) || {}),
      ...response,
      ...urlParams,
      phone: urlParams.currentAccNbr || urlParams.phone || response?.mobile,
    };
    // return;
    window.localStorage.setItem('initApp', JSON.stringify(initApp));
    await isLogin(configList);
    setLoading(false);
  };

  const qryUserInfoInEshop = async configList => {
    const initAppStr = window.localStorage.getItem('initApp') || '{}';
    const initApp = JSON.parse(initAppStr) || {};
    const urlParams = history.location.query || {};
    const res = await dispatch({
      type: 'index/qryEshopUser',
      payload: {
        userId: null,
      },
    });
    let initAppTemp = cloneDeep(initApp);
    initAppTemp = {
      ...urlParams,
      ...initAppTemp,
      ...(res || {}),
      phone: res?.mobilePhone || initApp.phone || urlParams.phone,
    };
    window.localStorage.setItem('initApp', JSON.stringify(initAppTemp));
    await isLogin(configList);
    setLoading(false);
  };

  const isNotLoginEshop = async gameCode => {
    // 查询eshop登录界面的url
    let eshopLoginUrl = '';
    if (gameCode) {
      const res = await dispatch({
        type: 'index/getConfigParamDXP',
        payload: {
          paramCodeList: ['LUCKY_DRAW_ESHOP_WEB_LOGIN_URL'],
        },
      });
      eshopLoginUrl = res.paramValue;
    } else {
      eshopLoginUrl = await dispatch({
        type: 'index/qryEshopLoginUrl',
        payload: 'LUCKY_DRAW_ESHOP_WEB_LOGIN_URL',
      });
    }
    if (navigator?.userAgent?.indexOf('mydito') > -1) {
      // app内打开，且未登录状态，需要先登录
      window.dito?.goToLogin ? window.dito.goToLogin() : window.clp?.needLogin?.();
    } else {
      // window.location.href = `${eshopLoginUrl}?returnUrl=${encodeURIComponent(window.location.href)}`;
      window.location.replace(
        `${eshopLoginUrl}?returnUrl=${encodeURIComponent(window.location.href)}`,
      );
    }
    // await notLogin();
    // setLoading(false);
  };
  const getLang = async appCode => {
    // 查询多语言的特性开关
    // const multilingualSwitch = await dispatch({
    //   type: 'index/getConfigParam',
    //   payload: {
    //     paramCode: 'DC_GCP_I18N',
    //   },
    // });

    // if (Number(multilingualSwitch?.paramValue) !== 1) {
    //   window.localStorage.setItem('GCP_i18n', JSON.stringify({}));
    //   window.localStorage.setItem('GAME_i18n', JSON.stringify({}));
    //   return;
    // }

    const url = window.location.href;
    const { promotionId } = history.location.query;

    const urlSearchParams = new URLSearchParams(url.split('?')[1]);
    let lang = urlSearchParams.get('lang');
    if (!lang) {
      if (window.clp) {
        try {
          lang = JSON.parse(window.clp?.getLoginInfo?.() || '{}')?.language;
        } catch (error) {
          lang = 'en'; // 默认语言
        }
      } else {
        lang = window.localStorage.getItem('lang');
      }
    }
    lang = lang || 'en';
    window.localStorage.setItem('langCode', lang);
    const staticJson = await dispatch({
      type: 'index/getLocalI18n',
      payload: {
        appCode,
      },
    });
    let dynamicJson = {};
    if (promotionId) {
      dynamicJson = await dispatch({
        type: 'index/getGameI18n',
        payload: {
          promotionId,
        },
      });
    }
    window.localStorage.setItem('GCP_i18n', JSON.stringify(staticJson?.[lang] || {}));
    window.localStorage.setItem('GAME_i18n', JSON.stringify(dynamicJson?.[lang] || {}));
    // 手动派发一个事件，通知上面的更新
    window.dispatchEvent(new Event('i18n-storage-change'));
  };

  // 获取用户登录信息，如果调用 window.dito 后有返回用户信息，就不需要再通过 JSBridge 或者 url 获取了
  const getInitApp = async appInfo => {
    const {
      promotionId,
      gameCode,
      product,
      token,
      userDimension,
      MSISDN,
      tenantId,
      userType,
      deviceType,
    } = history.location.query || {};
    // 是eshop，并且没有token表示没有登录，需要跳转到eshop登录页面
    if (!(token || appInfo.eshoptoken) && product === 'ESHOP') {
      isNotLoginEshop(gameCode);
      return;
    }
    let isWebTemp = false;
    if (deviceType === 'desktop' && getDeviceType() === 'desktop') {
      isWebTemp = true;
      dispatch({
        type: 'index/save',
        payload: {
          isWeb: true,
        },
      });
    }
    if (product) {
      dispatch({
        type: 'index/save',
        payload: {
          product,
          userDimension,
        },
      });
    }
    dispatch({
      type: 'index/save',
      payload: {
        gameCode,
        isDXP: true,
      },
    });
    const { brandKey } = getBrandInfo();
    let appCode = brandKey === 'HEYA' ? 'HEYA_GCP' : 'GCP';
    if (deviceType === 'desktop' && getDeviceType() === 'desktop') {
      appCode = 'GCP_WEB';
    }
    const { clientKey } = appInfo;
    const tokenJsonTemp = pickLocalTokenJson(clientKey, isWebTemp);
    loadThemeToken(appCode, tokenJsonTemp);

    const configList = await dispatch({
      type: 'index/getConfigParamBatch',
      payload: {
        paramCodeList: [
          'PROMOTION_PROGECT_IDENTIFICATION', // 查询当前项目
          'CURRENCY_SHOW_UNIT', // 查询金额单位
          'PROMOTION_IMAGE_SERVER_URL', // 查询云盘图片，json文件中url地址前缀
          'CEE_NUMBER_PREFIX_CFG', // 查询默认的电话号码前缀
          'TIME_DISPLAY_FORMAT', // 查询时间配置项
          'EVENT_REPORT_SERVER_URL', // 查询神策上报url地址
          'webs.ecare.signcode.develop.model', // 查询是否不需要鉴权，开发者模式不需要token
          'use.UC.authentication.switch', // 判断是否打开开关通过UC进行用户信息校验,UC鉴权调用各种接口只需要传token，其它用户信息都不需要
          'DC_LOYALTY_POINT-MULTIPLE-ACCOUNT', // 是否支持多积分账户
        ],
      },
    });
    const projectName = configList.find(
      item => item.paramCode === 'PROMOTION_PROGECT_IDENTIFICATION',
    )?.paramValue;
    const withoutAuthentification = configList.find(
      item => item.paramCode === 'webs.ecare.signcode.develop.model',
    )?.paramValue;
    const UCAuthentication =
      configList.find(item => item.paramCode === 'use.UC.authentication.switch') || {};
    const currencyUnit = configList.find(item => item.paramCode === 'CURRENCY_SHOW_UNIT') || {};
    const prefixJson =
      configList.find(item => item.paramCode === 'PROMOTION_IMAGE_SERVER_URL') || {};
    const prefixDefualt = configList.find(item => item.paramCode === 'CEE_NUMBER_PREFIX_CFG') || {};
    // // 校验是否是pto项目
    // const projectName = await dispatch({
    //   type: 'index/qryProject',
    //   payload: 'PROMOTION_PROGECT_IDENTIFICATION',
    // });
    const isPto = projectName === 'PTO';
    // 判断是否打开开关通过UC进行用户信息校验,UC鉴权调用各种接口只需要传token，其它用户信息都不需要
    // const UCAuthentication = await dispatch({
    //   type: 'index/isUCAuthentication',
    //   payload: {
    //     paramCode: 'use.UC.authentication.switch',
    //   },
    // });
    // 查询金额单位，
    // const currencyUnit = await dispatch({
    //   type: 'index/getConfigParam',
    //   payload: {
    //     paramCode: 'CURRENCY_SHOW_UNIT',
    //   },
    // });
    // 查询默认的电话号码前缀
    // const prefixDefualt = await dispatch({
    //   type: 'index/getConfigParam',
    //   payload: {
    //     paramCode: 'DATAMALL_DEFAULT_PREFIX',
    //   },
    // });
    // json前缀
    // const prefixJson = await dispatch({
    //   type: 'index/getConfigParam',
    //   payload: {
    //     paramCode: 'PROMOTION_IMAGE_SERVER_URL',
    //   },
    // });
    window.localStorage.setItem('prefixJson', prefixJson?.paramValue || '');
    // 查询是否不需要鉴权，开发者模式不需要token
    // const withoutAuthentification = await dispatch({
    //   type: 'index/qryWithoutAuthentification',
    //   payload: {
    //     paramCode: 'webs.ecare.signcode.develop.model',
    //   },
    // });

    // getLang(brandKey === 'HEYA' ? 'HEYA_GCP' : 'GCP');
    getLang(appInfo?.clientKey || 'GCP');

    const initAppObj = cloneDeep(appInfo);
    if (!isPto) {
      initAppObj.phone = initAppObj?.currentAccNbr || initAppObj.phone;
    }
    // 如果游戏用户维度是订户号码，优先取链接后的订户号码http：×××？MSISDN={}，南非
    // if (projectName === 'SA_SHOW') {
    if (userDimension === 'SUBS_MSISDN') {
      // MSISDN即表示带有前缀的电话号码
      initAppObj.phone = MSISDN || initAppObj.phone;
      initAppObj.prefix = '';
    }

    initAppObj.tenantId = tenantId;
    initAppObj.userType = userType;
    initAppObj.product = product || tenantId || '0';
    initAppObj.userDimension = userDimension || userType || '1';
    initAppObj.currencyUnit = currencyUnit?.paramValue;
    initAppObj.eshoptoken = token || initAppObj?.eshoptoken;
    initAppObj.prefix = initAppObj.prefix || '';
    // if (!initAppObj?.prefix && !(projectName === 'SA_SHOW')) {
    // 如果桥接中没有前缀并且url中没有MSISDN(带有号码的前缀，这里需要给prifix置为空字符串)
    if (!initAppObj?.prefix && !MSISDN) {
      initAppObj.prefix = prefixDefualt.paramValue;
    }
    window.localStorage.setItem('initApp', JSON.stringify(initAppObj));
    if (promotionId) {
      localStorage.setItem('promotionId', JSON.stringify({ promotionId }));
    }
    // eshop页面，有token表示已登录，eshop用户信息需要查询接口获取，不管是在App中还是浏览器中打开
    if (initAppObj.eshoptoken && product === 'ESHOP') {
      await qryUserInfoInEshop(configList);
      return;
    }
    // if (UCAuthentication.paramValue === 'Y') {
    //   const userInfo = window?.DIGIX?.getUserInfo();
    //   const initAppInfoTemp = {
    //     ...initAppObj,
    //     ...userInfo,
    //   };
    //   window.localStorage.setItem('initApp', JSON.stringify(initAppInfoTemp));
    //   if (initAppInfoTemp.token) {
    //     await isLogin();
    //     setLoading(false);
    //     return;
    //   }
    // }
    // console.log('2222222222222', window?.APP);
    if (window?.APP && Number(tenantId) === 2) {
      // 代理商桥接
      window?.APP?.invokeClientMethod('getUserInfo', null, async responseData => {
        const jsonObj = responseData || {};
        // alert("jsonObj selectedSub:",jsonObj);
        const { token: tokenTemp } = jsonObj;
        const initAppInfoTemp = {
          token: tokenTemp || token,
          ...initAppObj,
          ...responseData,
        };
        window.localStorage.setItem('initApp', JSON.stringify(initAppInfoTemp));
        if (initAppInfoTemp.token) {
          await isLogin(configList);
          setLoading(false);
          // return;
        } else {
          await notLogin(projectName);
          setLoading(false);
        }
      });
      return;
    }
    if (UCAuthentication.paramValue === 'Y') {
      if (window?.DIGIX) {
        window?.DIGIX?.invokeClientMethod('getUserInfo', null, async responseData => {
          const jsonObj = responseData || {};
          // alert("jsonObj selectedSub:",jsonObj);
          const { custInfo, subInfo: _subInfo } = jsonObj;
          // 新建客户回来的时候 订户信息取subInfo，其他情况下subInfo为null
          // dispatch({
          //   type: 'global/save',
          //   payload: {
          //     subInfo: !isEmpty(_subInfo) ? _subInfo : custInfo,
          //   },
          // });
          const userInfo = !isEmpty(_subInfo) ? _subInfo : custInfo;
          const initAppInfoTemp = {
            ...initAppObj,
            ...userInfo,
            ...responseData,
          };
          initAppInfoTemp.prefix = '';
          initAppInfoTemp.phone = '';
          window.localStorage.setItem('initApp', JSON.stringify(initAppInfoTemp));
          if (initAppInfoTemp.token) {
            await isLogin(configList);
            setLoading(false);
            // return;
          } else {
            const urlParams = history.location.query || {};
            if (!isEmpty(urlParams.token)) {
              await isLogin(configList);
              setLoading(false);
            } else {
              await notLogin(projectName);
              setLoading(false);
            }
          }
        });
        return;
      }
    }
    await qryUserInfoByTokenDXP();
    if (!isEmpty(appInfo) && appInfo.token) {
      await isLogin(configList);
      setLoading(false);
      return;
    }
    // 兼容老版本
    if (window?.connectJSBridge) {
      window.connectJSBridge(bridge => {
        bridge.callHandler('initApp', null, responseData => {
          const jsonObj = JSON.parse(responseData || {}); // 手机号，手机型号，用户token等
          window.localStorage.setItem('initApp', JSON.stringify(jsonObj));
        });
      });
    }
    setTimeout(async () => {
      const initAppStr = window.localStorage.getItem('initApp') || '{}';
      const initApp = JSON.parse(initAppStr) || {};
      // 产品与Pto，此时initApp初始为app内用户信息,此时的token只是app中获取，不包括url上的token
      // dxp因为走了qryUserInfoDXP的接口逻辑，initApp的token应该是url中的token了
      if (!isEmpty(initApp.token)) {
        await isLogin(configList);
        setLoading(false);
      } else {
        // initApp 没有获取到 用户数据，就从 url 上获取
        const urlParams = history.location.query || {};
        if (!isEmpty(urlParams.token)) {
          // 浏览器有token，并且打开了uc开关，那么直接登录，用户信息不需要
          if (UCAuthentication.paramValue === 'Y') {
            const initAppTemp = {
              ...initApp,
              ...urlParams,
            };
            // return;
            window.localStorage.setItem('initApp', JSON.stringify(initAppTemp));
            await isLogin(configList);
            setLoading(false);
            return;
          }
          // 浏览器有token，调通uc接口获取用户信息，这个是浏览器打开，uc鉴权没开，通过token查一些用户信息
          qryUserInfoByToken(urlParams.token, configList);
        } else {
          // 如果游戏用户维度是订户号码，打开了开发者模式，那么不需要token也算登录
          if (withoutAuthentification === 'true') {
            await isLogin(configList);
            setLoading(false);
            return;
          }
          await notLogin(projectName);
          setLoading(false);
        }
      }
    }, 300);
  };

  const handleInit = async () => {
    setLoading(true);
    initLocalStorage();
    // 先通过 getAppInfo 方法调用 window.dito，判断是否有用户登录信息
    getAppInfo(getInitApp);
  };

  // 登录成功通知
  window.loginSuccessNotification = param => {
    if (param) window.location.reload();
  };

  useEffect(() => {
    const initFunction = async () => {
      await dispatch({
        type: 'index/qryDefaultConfig',
      });
      // // 查 access token
      // await qryApiSgAuthToken();
      let defaultConfig = {};
      try {
        defaultConfig = JSON.parse(window.sessionStorage.getItem('x-default-config')) || {};
      } catch {
        //
      }
      if (defaultConfig?.APIGEE_TOKEN_ENABLED) {
        // 查 access token
        await qryApiSgAuthToken();
      }
      if (
        pathname.includes('/utm/') ||
        pathname.includes('/fam/') ||
        pathname.includes('/hilife/')
      ) {
        setLoading(true);
        const { deviceType } = history.location.query || {};
        let isWebTemp = false;
        if (deviceType === 'desktop' && getDeviceType() === 'desktop') {
          isWebTemp = true;
        }
        const { brandKey } = getBrandInfo();
        let appCode = brandKey === 'HEYA' ? 'HEYA_GCP' : 'GCP';
        if (deviceType === 'desktop' && getDeviceType() === 'desktop') {
          appCode = 'GCP_WEB';
        }
        const initAppInfo = JSON.parse(window.localStorage.getItem('initApp') || '{}');
        const tokenJsonTemp = pickLocalTokenJson(initAppInfo.clientKey, isWebTemp);
        loadThemeToken(appCode, tokenJsonTemp, true);
        return;
      }
      handleInit();
      dispatch({
        type: 'tokenModal/setTokenModal',
        payload: {
          root: localToken,
        },
      });
      TokenManager.setTokenRef({
        root: localToken,
      });
      // 查询云盘前缀，
      // dispatch({
      //   type: 'index/getConfigParam',
      //   payload: {
      //     paramCode: 'PROMOTION_IMAGE_SERVER_URL',
      //   },
      // }).then(res => {
      //   dispatch({
      //     type: 'index/getCloudDiskFile',
      //     // payload: `${res.paramValue.replace('http://10.45.80.101:8090', 'http://localhost:8000')}luckyDraw/Picture/token.json`,
      //     payload: `${res.paramValue}luckyDraw/Picture/token.json`,
      //   }).then(tokenFile => {
      //     tokenManager.loadExternalToken(tokenFile || tokenJson);
      //     dispatch({
      //       type: 'index/save',
      //       payload: {
      //         dxpToken: tokenFile || tokenJson,
      //       },
      //     });
      //   });
      // });
    };
    initLocalStorage();
    initFunction();
  }, []);

  if (loading) {
    return (
      <div className={styles.webWrap}>
        <div className={`${styles.BaseLayout} ${isWeb && styles.webBaseLayout}`}>
          <Skeleton
            active
            paragraph={{
              rows: 20,
            }}
          />
        </div>
      </div>
    );
  }

  const isUtm =
    pathname.includes('/utm/') ||
    pathname.includes('/fam/') ||
    pathname.includes('/hilife/') ||
    false;

  return (
    <>
      {luckyDrawPage && (
        <ConfigProvider locale={enUS}>
          <div className={`${styles.webWrap} ${isUtm && styles.utmWebWrap}`}>
            <GlobalTokenProvider>
              {/* 应用内容 */}
              <div
                id="baseLayoutWrap"
                className={`${styles.BaseLayout} gcpPreview ${isUtm && styles.utmWrap} ${
                  isWeb && styles.webBaseLayout
                }`}
              >
                {children}
              </div>
            </GlobalTokenProvider>
          </div>
        </ConfigProvider>
      )}
      {open && renderOpenApp()}
    </>
  );
};

export default connect(({ TokenModal, index }) => ({
  isWeb: index.isWeb,
  ...TokenModal,
}))(BaseLayout);
